import { AnimationRoot, AnimationWrapper } from './Animation.styles'

export const Animation = () => {
  return (
    <AnimationRoot>
      <AnimationWrapper>
        <object
          type="image/svg+xml"
          data={'/assets/raw-food-subscription/high-five.svg'}
          aria-hidden
        />
      </AnimationWrapper>
    </AnimationRoot>
  )
}
